/* ==========================================================================
   2026-11-03 - two fixes that also cover pages created later
   1. EMPTY BOXES: PagePilot sometimes pastes invisible control characters
      (U+0000-U+001F) into text blocks; browsers draw them as "□□□□". They are
      removed from the page text, and a line left empty is hidden.
   2. TECHNISCHE DATEN: new pages get a loose full-width theme "rich text"
      section (heading + text). When the buy box has an EMPTY PagePilot
      accordion, the section is moved into it as a collapsible row (+ icon),
      copying the look of the page's FAQ rows. Pages fixed in the template
      already have no loose section, so nothing runs there.
   ========================================================================== */
(function () {
  var CTRL = /[\u0000-\u0008\u000B\u000C\u000E-\u001F]/g;

  function cleanControlChars(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var hits = [];
    while (walker.nextNode()) {
      CTRL.lastIndex = 0;
      if (CTRL.test(walker.currentNode.nodeValue)) hits.push(walker.currentNode);
    }
    hits.forEach(function (node) {
      if (node.parentElement && /^(SCRIPT|STYLE|TEXTAREA)$/.test(node.parentElement.tagName)) return;
      node.nodeValue = node.nodeValue.replace(CTRL, '');
      var block = node.parentElement && node.parentElement.closest('.pagepilot-block, p, li');
      if (block && !block.textContent.trim() && !block.querySelector('img, svg, video, iframe, input, select, button')) {
        block.style.display = 'none';
      }
    });
  }

  function moveTechnicalData() {
    var empty = Array.prototype.find.call(
      document.querySelectorAll('.pp-product-details .pp-accordion, [id*="static-pagepilot_product_details"] .pp-accordion'),
      function (acc) { return !acc.querySelector('.pp-accordion-row'); }
    ) || Array.prototype.find.call(document.querySelectorAll('.pp-accordion'), function (acc) {
      return !acc.querySelector('.pp-accordion-row') && acc.closest('[id*="v2p3ry3hl"]');
    });
    if (!empty) return;
    var template = Array.prototype.find.call(document.querySelectorAll('.pp-accordion-row'), function (row) {
      return row.querySelector('details > summary') && row.querySelector('details > article p');
    });
    if (!template) return;

    document.querySelectorAll('.shopify-section[id*="__rich_text"]').forEach(function (section) {
      if (section.dataset.znMoved) return;
      var heading = section.querySelector('h1, h2, h3, h4, .h1, .h2, .h3, .rich-text__heading');
      if (!heading) return;
      var title = heading.textContent.trim();
      if (!title) return;
      var body = document.createElement('div');
      section.querySelectorAll('p, ul, ol, table').forEach(function (el) {
        if (!heading.contains(el) && !el.parentElement.closest('p, ul, ol, table')) body.appendChild(el.cloneNode(true));
      });
      if (!body.textContent.trim()) return;

      var row = template.cloneNode(true);
      row.querySelectorAll('[id]').forEach(function (el) { el.removeAttribute('id'); });
      var details = row.querySelector('details');
      details.removeAttribute('open');
      var label = Array.prototype.find.call(details.querySelectorAll('summary span'), function (s) {
        return !s.querySelector('span, svg') && s.textContent.trim();
      });
      if (!label) return;
      label.textContent = title;
      var firstP = details.querySelector('article p');
      var holder = firstP.parentElement;
      holder.innerHTML = body.innerHTML;
      var summary = details.querySelector('summary');
      summary.style.setProperty('--font-size', '16px');
      summary.style.setProperty('--font-size-mobile', '15px');
      summary.style.setProperty('--font-weight', '600');
      summary.style.setProperty('--font-weight-mobile', '600');
      empty.appendChild(row);
      section.dataset.znMoved = '1';
      section.style.display = 'none';
    });
  }

  function run() {
    try { cleanControlChars(document.querySelector('main') || document.body); } catch (e) {}
    try { moveTechnicalData(); } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  window.addEventListener('load', run);
  setTimeout(run, 3000);
})();

/* ===================================================================
   SHOW THE COLOUR'S PHOTO WHEN A BUNDLE TIER IS CHOSEN - every product page
   -------------------------------------------------------------------
   Operator 2026-10-27 (Bundtzy, desktop): "normally when I click on the
   variant, the variant image changes automatically, but it's not the
   case". Tapping a Wizio tier (1/2/3 Stueck) switches the active
   colour without any change event, so nothing moved the gallery - and
   since pages now open on photo 1 the gap shows. After a real tap on a
   tier, show the photo of that tier's first colour. Photos are found by
   their media id (never by position: PagePilot reorders its strip).
   Added 2026-10-27.
   =================================================================== */
(function () {
  if (!/\/products\//.test(location.pathname)) return;
  var prod = null;
  fetch(location.pathname.replace(/\/$/, '') + '.js').then(function (r) { return r.json(); })
    .then(function (p) { prod = p; }).catch(function () {});

  function show(v) {
    if (!v || !v.featured_media) return;
    var id = String(v.featured_media.id);
    var src = v.featured_image && v.featured_image.src;
    // Old PagePilot: swipe strip (phone) / thumbnail row (desktop).
    var strip = document.getElementById('pp-image-scroll-container');
    if (strip) {
      var el = strip.querySelector('[data-id="' + id + '"]');
      if (el) {
        var item = el;
        while (item.parentElement && item.parentElement !== strip) item = item.parentElement;
        strip.style.scrollBehavior = 'auto';
        strip.scrollLeft = strip.scrollLeft + item.getBoundingClientRect().left - strip.getBoundingClientRect().left;
      }
    }
    // Old PagePilot: big photo.
    var main = document.getElementById('pp-main-product-image');
    if (main && src) {
      var q = ''; try { q = new URL(main.src, location.origin).search; } catch (e) {}
      main.src = (src.indexOf('//') === 0 ? location.protocol + src : src).split('?')[0] + q;
      main.removeAttribute('srcset');
    }
    // New PagePilot: Swiper.
    var g = document.querySelector('.pp-product-gallery-main');
    var sw = g && g.swiper;
    if (sw) {
      Array.prototype.some.call(sw.slides, function (s, i) {
        if (s.classList.contains('swiper-slide-duplicate') || String(s.getAttribute('data-media-id')) !== id) return false;
        var idx = s.hasAttribute('data-swiper-slide-index') ? +s.getAttribute('data-swiper-slide-index') : i;
        if (sw.params && sw.params.loop && sw.slideToLoop) sw.slideToLoop(idx, 300); else sw.slideTo(idx, 300);
        return true;
      });
    }
    // Default (Prestige) pages: Flickity slideshow.
    var ss = document.querySelector('.Product__Slideshow');
    var fl = ss && window.Flickity && Flickity.data(ss);
    if (fl && v.featured_image) {
      var cells = Array.prototype.slice.call(ss.querySelectorAll('.Product__SlideItem'));
      var ci = cells.findIndex(function (c) { return String(c.getAttribute('data-image-id')) === String(v.featured_image.id); });
      if (ci >= 0) fl.select(ci, false, true);
    }
  }

  document.addEventListener('click', function (e) {
    if (!e.isTrusted || !e.target.closest) return;
    var tier = e.target.closest('.bdl-quantity-item');
    if (!tier || e.target.closest('select')) return;
    setTimeout(function () {
      if (!prod) return;
      var act = document.querySelector('.bdl-quantity-item.active');
      var pk = act && act.querySelector('select.bdl-quantity-variants-picker');
      var v = pk && prod.variants.find(function (x) { return String(x.id) === String(pk.value); });
      show(v);
    }, 350);
  }, true);
})();

/* ===================================================================
   PAGEPILOT PAGES OPEN ON PHOTO 1 - every product page
   -------------------------------------------------------------------
   Operator 2026-10-27 (phone): "the image that appears first is the
   first variant one, instead of the first image". PagePilot builds its
   gallery with the selected colour's photo moved to the FRONT (old
   template: the phone swipe strip; new template: the Swiper slides) -
   the first colour on a plain link, the linked colour on ?variant=.
   On load it also scrolls the strip / swaps the big desktop photo to
   that colour. Put the strip back in the product's own photo order,
   start the Swiper on photo 1, and keep both on photo 1 until the
   visitor touches the gallery, a colour or the bundle; after that the
   photos follow their choice as before. Default (Prestige) pages are
   handled in sections/product-template.liquid. Added 2026-10-27.
   =================================================================== */
(function () {
  if (!/\/products\//.test(location.pathname)) return;
  var touched = false;
  var ZONES = '#pp-image-scroll-container, .pp-scroll-arrow, #pp-main-product-image, .pp-variant-picker, ' +
    'pagepilot-variant-picker, .pp-product-gallery-main, .pp-product-gallery-thumbs, .bdl-quantity-generate, ' +
    '.ProductForm, [class*="giraffly"]';
  ['pointerdown', 'touchstart', 'keydown'].forEach(function (type) {
    document.addEventListener(type, function (e) {
      if (e.target && e.target.closest && e.target.closest(ZONES)) touched = true;
    }, { capture: true, passive: true });
  });
  // Apps fire their own change events while they draw; only a real one counts.
  document.addEventListener('change', function (e) { if (e.isTrusted) touched = true; }, true);

  var order = null, firstId = null, firstSrc = null, sorted = false;
  fetch(location.pathname.replace(/\/$/, '') + '.js').then(function (r) { return r.json(); }).then(function (p) {
    order = {};
    (p.media || []).forEach(function (m, i) { order[String(m.id)] = i; });
    var m0 = p.media && p.media[0];
    firstId = m0 ? String(m0.id) : null;
    firstSrc = (m0 && (m0.src || (m0.preview_image && m0.preview_image.src))) || p.featured_image || null;
    if (firstSrc && firstSrc.indexOf('//') === 0) firstSrc = location.protocol + firstSrc;
    run();
  }).catch(function () {});

  function idOf(el) {
    var x = el.getAttribute('data-id') ? el : el.querySelector('[data-id]');
    return x ? String(x.getAttribute('data-id')) : null;
  }
  function base(u) { return String(u || '').split('?')[0].split('/').pop().replace(/_\d*x\d*(?=\.)/, ''); }

  function run() {
    if (touched || !order) return;
    // Old template, phone: restore the product's photo order once, then hold the strip at photo 1.
    var strip = document.getElementById('pp-image-scroll-container');
    if (strip) {
      if (!sorted) {
        var kids = Array.prototype.slice.call(strip.children).filter(function (c) { return idOf(c) in order; });
        if (kids.length > 1) {
          kids.sort(function (a, b) { return order[idOf(a)] - order[idOf(b)]; })
            .forEach(function (c) { strip.appendChild(c); });
          sorted = true;
        }
      }
      if (strip.scrollLeft > 2) { strip.style.scrollBehavior = 'auto'; strip.scrollLeft = 0; }
    }
    // Old template, desktop: the big photo.
    var main = document.getElementById('pp-main-product-image');
    if (main && firstSrc && base(main.getAttribute('src')) !== base(firstSrc)) {
      var q = ''; try { q = new URL(main.src, location.origin).search; } catch (e) {}
      main.src = firstSrc.split('?')[0] + q;
      main.removeAttribute('srcset');
    }
    // New template: Swiper gallery (the colour's slide is first, photo 1 comes later).
    var g = document.querySelector('.pp-product-gallery-main');
    var sw = g && g.swiper;
    if (sw && firstId) {
      var target = -1;
      Array.prototype.forEach.call(sw.slides, function (s, i) {
        if (target < 0 && !s.classList.contains('swiper-slide-duplicate') && String(s.getAttribute('data-media-id')) === firstId) {
          target = s.hasAttribute('data-swiper-slide-index') ? +s.getAttribute('data-swiper-slide-index') : i;
        }
      });
      if (target >= 0 && sw.realIndex !== target) {
        if (sw.params && sw.params.loop && sw.slideToLoop) sw.slideToLoop(target, 0, false);
        else sw.slideTo(target, 0, false);
      }
    }
  }
  document.addEventListener('DOMContentLoaded', run);
  window.addEventListener('load', run);
  var n = 0, t = setInterval(function () { run(); if (++n >= 24 || touched) clearInterval(t); }, 250);
})();

/* ===================================================================
   STICKY ADD-TO-CART BAR ONLY AFTER THE MAIN BUTTON - product pages
   -------------------------------------------------------------------
   Giraffly shows its bottom bar on the first scroll (desktop) or once
   the visitor passes ~17% of the page minus 900px (phone) - often while
   the bundle choices and the main "WARENKORB" button are still on
   screen. Visitors then tap the bar, which adds ITS OWN single choice
   instead of the bundle they picked. Keep the bar invisible until the
   page's real add-to-cart button has scrolled off the top of the screen.
   The real button differs per page type: Wizio bundle = plain <button>
   "WARENKORB", old PagePilot = .pagepilot-button-atc, new PagePilot =
   button.pp-add-to-cart, default = .ProductForm__AddToCart (hidden on
   bundle pages, so pick the first VISIBLE one). Added 2026-10-27.
   =================================================================== */
(function () {
  if (!/\/products\//.test(location.pathname)) return;
  var css = document.createElement('style');
  css.textContent = 'html body .zn-bar-wait{visibility:hidden!important;opacity:0!important;pointer-events:none!important}';
  (document.head || document.documentElement).appendChild(css);

  function fixedAncestor(el) {
    for (var p = el; p && p !== document.body; p = p.parentElement) {
      if (getComputedStyle(p).position === 'fixed') return true;
    }
    return false;
  }
  function mainButton() {
    var list = document.querySelectorAll('button, .pagepilot-button-atc');
    for (var i = 0; i < list.length; i++) {
      var b = list[i];
      if (!/warenkorb/i.test(b.textContent || '')) continue;
      if (b.closest('[class*="giraffly"], .wizio-cart')) continue;
      var r = b.getBoundingClientRect();
      if (r.width < 100 || r.height < 20 || fixedAncestor(b)) continue;
      return b;
    }
    return null;
  }
  var btn = null;
  function update() {
    if (!btn || !btn.isConnected || !btn.getBoundingClientRect().width) btn = mainButton();
    var wait = btn ? btn.getBoundingClientRect().bottom > 0 : false;
    var bars = document.querySelectorAll('.giraffly_phoneButtonPreview, .giraffly_PCPreview_BOX');
    for (var i = 0; i < bars.length; i++) bars[i].classList.toggle('zn-bar-wait', wait);
  }
  update();
  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
  window.addEventListener('load', update);
  var n = 0, t = setInterval(function () { update(); if (++n >= 40) clearInterval(t); }, 500);
})();

/* ===================================================================
   FOOTER ROOM UNDER THE GIRAFFLY BAR - every page
   -------------------------------------------------------------------
   The Giraffly add-to-cart bar (.giraffly_PCPreview_BOX, ~74px, fixed
   at the bottom on desktop) covers the footer's last row ("(c) Zanaro
   Berlin" + payment icons). Pad the footer by the bar's height while
   the bar shows. PagePilot's block in theme.liquid stays untouched.
   Added 2026-10-26.
   =================================================================== */
(function () {
  function pad() {
    var bar = document.querySelector('.giraffly_PCPreview_BOX');
    var h = bar && getComputedStyle(bar).display !== 'none' ? bar.getBoundingClientRect().height : 0;
    var f = document.getElementById('shopify-section-footer');
    if (f) f.style.paddingBottom = h ? (h + 10) + 'px' : '';
  }
  window.addEventListener('load', pad);
  window.addEventListener('resize', pad);
  var n = 0, t = setInterval(function () { pad(); if (++n >= 20) clearInterval(t); }, 500);
})();

/* ===================================================================
   GARBLED REVIEW LETTERS - EZ reviews app
   -------------------------------------------------------------------
   Some imported reviews were saved as UTF-8 read as Latin-1, so they
   show "fÃ¼r", "SpaÃŸ", "â€“". Repair those text nodes in place inside
   #ez_review_containter (the app's own spelling). The app loads late
   and pages through reviews, so re-run for 30 s and on every change.
   Added 2026-10-26.
   =================================================================== */
(function () {
  var BAD = /Ã[\u0080-\u00BF\u0152\u0153\u0160\u0161\u0178\u017D\u017E\u0192\u02C6\u02DC\u2013-\u203A\u20AC\u2122]|â€/;
  var CP = { 0x20AC: 0x80, 0x201A: 0x82, 0x0192: 0x83, 0x201E: 0x84, 0x2026: 0x85, 0x2020: 0x86, 0x2021: 0x87, 0x02C6: 0x88,
    0x2030: 0x89, 0x0160: 0x8A, 0x2039: 0x8B, 0x0152: 0x8C, 0x017D: 0x8E, 0x2018: 0x91, 0x2019: 0x92, 0x201C: 0x93,
    0x201D: 0x94, 0x2022: 0x95, 0x2013: 0x96, 0x2014: 0x97, 0x02DC: 0x98, 0x2122: 0x99, 0x0161: 0x9A, 0x203A: 0x9B,
    0x0153: 0x9C, 0x017E: 0x9E, 0x0178: 0x9F };
  function repair(s) {
    var bytes = [];
    for (var i = 0; i < s.length; i++) {
      var c = s.charCodeAt(i);
      if (c < 256) bytes.push(c); else if (CP[c]) bytes.push(CP[c]); else return s;
    }
    try { return decodeURIComponent(bytes.map(function (b) { return '%' + (b < 16 ? '0' : '') + b.toString(16); }).join('')); }
    catch (e) { return s; }
  }
  function fix() {
    var box = document.getElementById('ez_review_containter');
    if (!box) return;
    var w = document.createTreeWalker(box, NodeFilter.SHOW_TEXT, null), n;
    while ((n = w.nextNode())) {
      if (BAD.test(n.nodeValue)) {
        var r = n.nodeValue.replace(/[^\s]*[ÃÂâ][^\s]*/g, function (word) { return BAD.test(word) || /Â/.test(word) ? repair(word) : word; });
        if (r !== n.nodeValue) n.nodeValue = r;
      }
    }
  }
  fix();
  document.addEventListener('DOMContentLoaded', fix);
  var k = 0, t = setInterval(function () { fix(); if (++k >= 60) clearInterval(t); }, 500);
  if (window.MutationObserver) new MutationObserver(function () { fix(); }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
})();

/* ===================================================================
   MAGNETLASH - Dutch option names
   -------------------------------------------------------------------
   The product was cloned from Solundi and kept its Dutch option name
   and values. Show them in German on the product page. Only the shown
   text changes: each <option> keeps its original value so the right
   variant still reaches the cart. Added 2026-10-26.
   =================================================================== */
(function () {
  if (!/\/products\/magnetlash/i.test(decodeURIComponent(location.pathname))) return;
  var DE = [
    [/^opties\b/i, 'Optionen'],
    [/\((\d+) paar nog op voorraad\)/i, '(nur noch $1 Paar auf Lager)'],
    [/\bNatuurlijk\b/i, 'Natürlich']
  ];
  function de(s) {
    var t = s.trim(), r = t;
    for (var i = 0; i < DE.length; i++) r = r.replace(DE[i][0], DE[i][1]);
    return r === t ? s : s.replace(t, r);
  }
  function run() {
    var opts = document.querySelectorAll('option');
    for (var i = 0; i < opts.length; i++) {
      var o = opts[i], v = de(o.textContent);
      if (v !== o.textContent) { if (!o.hasAttribute('value')) o.setAttribute('value', o.value); o.textContent = v; }
    }
    var root = document.querySelector('main') || document.body;
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null), n;
    while ((n = w.nextNode())) {
      if (n.parentNode && n.parentNode.tagName === 'OPTION') continue;
      if (/opties|paar nog op voorraad|Natuurlijk/i.test(n.nodeValue)) { var x = de(n.nodeValue); if (x !== n.nodeValue) n.nodeValue = x; }
    }
  }
  run();
  document.addEventListener('DOMContentLoaded', run);
  var k = 0, t = setInterval(function () { run(); if (++k >= 20) clearInterval(t); }, 500);
  // The theme rewrites the option label each time a value is chosen.
  if (window.MutationObserver) new MutationObserver(run).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
})();

/* ===================================================================
   RIVERTY PAYMENT LINE - new PagePilot templates
   -------------------------------------------------------------------
   New templates show a lightning (zap) icon + "Sicher bezahlen mit
   Kreditkarte oder PayPal" (English: "Pay securely with credit card or
   PayPal"). Old templates show the Riverty logo + "Zahlen Sie spaeter
   oder in 3 Teilen mit Riverty". Rewrite the text (German or English,
   whichever the page is in) and swap the icon for the same riverty.png
   at 14px high. Added 2026-10-16.
   =================================================================== */
(function () {
  var LOGO = 'https://cdn.shopify.com/s/files/1/0601/8587/0473/files/riverty.png?v=1774172153';
  var DE = 'Zahlen Sie später oder in 3 Teilen mit <b>Riverty</b>';
  var EN = 'Pay later or in 3 installments with <b>Riverty</b>';
  var MATCH = /(Kreditkarte oder|credit card or)\s*PayPal/i;

  var css = document.createElement('style');
  css.textContent =
    'html body .zn-riverty-wrap{width:auto!important;height:auto!important;min-width:0!important;background:transparent!important;border-radius:0!important}' +
    'html body .zn-riverty-logo{display:block!important;height:14px!important;width:auto!important;max-width:none!important;object-fit:contain;margin:0!important}';
  (document.head || document.documentElement).appendChild(css);

  function swap() {
    var icons = document.querySelectorAll('svg[data-lucide="zap"], svg.lucide-zap, i[data-lucide="zap"]');
    for (var i = 0; i < icons.length; i++) {
      var icon = icons[i], wrap = icon.parentElement, row = wrap && wrap.parentElement;
      if (!row || !MATCH.test(row.textContent || '')) continue;
      var texts = row.querySelectorAll('div');
      for (var j = 0; j < texts.length; j++) {
        var t = texts[j];
        if (t.children.length <= 1 && MATCH.test(t.textContent || '')) {
          t.innerHTML = /Kreditkarte/i.test(t.textContent) ? DE : EN;
        }
      }
      var img = document.createElement('img');
      img.src = LOGO; img.alt = 'Riverty'; img.width = 23; img.height = 14;
      img.className = 'zn-riverty-logo';
      wrap.classList.add('zn-riverty-wrap');
      wrap.replaceChild(img, icon);
    }
  }
  swap();
  document.addEventListener('DOMContentLoaded', swap);
  window.addEventListener('load', swap);
  var runs = 0, timer = setInterval(function () { swap(); if (++runs >= 20) clearInterval(timer); }, 500);
})();

/* ===================================================================
   "ACHTUNG!" DATE BOX - old template block on every product page
   -------------------------------------------------------------------
   Old PagePilot templates have a custom_liquid section right above the
   Trustpilot reviews:
     Achtung! Bestellen Sie bis einschliesslich <Wochentag, TT.MM.JJJJ>,
     um von der Rabattaktion zu profitieren.
   (grey #f2f2f2 box, today's date filled in by an inline script).
   New PagePilot templates do not have it. This injects the same markup
   directly above the Trustpilot block (#tp-global-reviews, or the
   section holding a template's own .TP-heading) on every product page
   that lacks #dynamic-discount-message. Added 2026-10-16.
   =================================================================== */
(function () {
  var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
  var isProduct = (meta && meta.page && meta.page.pageType === 'product') || /\/products\//.test(location.pathname);
  if (!isProduct) return;

  var TAGE = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];

  function today() {
    var d = new Date();
    var tag = String(d.getDate()).padStart(2, '0');
    var monat = String(d.getMonth() + 1).padStart(2, '0');
    return TAGE[d.getDay()] + ', ' + tag + '.' + monat + '.' + d.getFullYear();
  }

  function anchor() {
    var g = document.getElementById('tp-global-reviews');
    if (g && g.parentNode && !g.hidden) return g;
    var h = document.querySelector('.TP-heading');
    if (!h) return null;
    return h.closest('.shopify-section') || h.closest('.pagepilot-section');
  }

  function inject() {
    if (document.getElementById('dynamic-discount-message')) return true;
    var a = anchor();
    if (!a || !a.parentNode) return false;
    var wrap = document.createElement('div');
    wrap.className = 'pagepilot-section pagepilot-custom-liquid zn-achtung-auto';
    wrap.innerHTML =
      '<div class="pagepilot-wrapper">' +
        '<div id="dynamic-discount-message" style="text-align: center; font-size: 16px; padding: 15px; background-color: #f2f2f2; border-radius: 0px;">' +
          '<span style="font-size: large;"><b>Achtung!</b></span> Bestellen Sie bis einschließlich ' +
          '<span id="today-date" style="color: #C5B79A; font-weight: bold;">' + today() + '</span>' +
          ', um von der Rabattaktion zu profitieren.' +
        '</div>' +
      '</div>';
    a.parentNode.insertBefore(wrap, a);
    return true;
  }

  // The Trustpilot block decides late whether it stays (it removes itself when a
  // template has its own copy), so retry for ~10s until an anchor is settled.
  var runs = 0;
  function tick() { if (inject() || ++runs >= 20) clearInterval(timer); }
  var timer = setInterval(tick, 500);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tick); else tick();
})();

/* ===================================================================
   DESKTOP GALLERY ARROWS - old PagePilot templates
   -------------------------------------------------------------------
   Old PagePilot pages show a big image + thumbnail grid on desktop
   (#pp-main-product-image, .pp-thumbnail with onclick ppSetCurrentImage).
   The theme's arrow script only runs on phones (<=768px), so desktop
   had no way to step through the photos except clicking thumbnails.
   This adds a left/right arrow on the big image that clicks the
   previous/next thumbnail (wrapping around), so the thumbnail border
   and any other thumbnail behaviour stay in sync. The current photo is
   read from the big image's src each time, so variant changes that
   swap the image are respected. Added 2026-10-02.
   =================================================================== */
(function () {
  function path(u) {
    return String(u || '').split('?')[0].replace(/^https?:/, '').replace(/^\/\/[^/]+/, '');
  }

  function init() {
    var main = document.getElementById('pp-main-product-image');
    if (!main || main.getAttribute('data-zn-arrows')) return;
    var wrap = main.parentElement;
    var thumbs = Array.prototype.slice.call(document.querySelectorAll('#pp-image-scroll-container .pp-thumbnail'));
    if (!wrap || thumbs.length < 2) return;
    main.setAttribute('data-zn-arrows', '1');

    if (getComputedStyle(wrap).position === 'static') wrap.style.position = 'relative';

    function current() {
      var m = path(main.src);
      for (var i = 0; i < thumbs.length; i++) {
        var img = thumbs[i].querySelector('img');
        if (img && path(img.src) === m) return i;
      }
      return 0;
    }

    function go(step) {
      var n = thumbs.length;
      thumbs[(current() + step + n) % n].click();
    }

    [['left', -1, '‹', 'Vorheriges Bild'], ['right', 1, '›', 'Nächstes Bild']].forEach(function (a) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'zn-pp-desk-arrow zn-pp-desk-arrow-' + a[0];
      b.setAttribute('aria-label', a[3]);
      b.innerHTML = a[2];
      b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(a[1]); });
      wrap.appendChild(b);
    });
  }

  var css = document.createElement('style');
  css.textContent =
    '.zn-pp-desk-arrow{position:absolute;top:50%;transform:translateY(-50%);z-index:10;width:40px;height:40px;' +
    'background:#f5f5f5;border:0;border-radius:8px;display:flex;align-items:center;justify-content:center;' +
    'font-size:26px;line-height:1;color:#333;box-shadow:0 1px 4px rgba(0,0,0,.15);cursor:pointer;user-select:none;' +
    'padding:0 0 3px;transition:background .2s ease}' +
    '.zn-pp-desk-arrow:hover{background:#eaeaea}' +
    '.zn-pp-desk-arrow-left{left:10px}.zn-pp-desk-arrow-right{right:10px}' +
    '@media (max-width:768px){.zn-pp-desk-arrow{display:none!important}}';
  (document.head || document.documentElement).appendChild(css);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  window.addEventListener('load', init);
})();

/* ===================================================================
   STOCK ALERT - old template line on every product page
   -------------------------------------------------------------------
   Old PagePilot templates hand-code this block above the bundle picker:
     [red pulse GIF] Nur noch 3 auf Lager
   New PagePilot templates do not, so it is injected here for every
   product page that lacks it - current and future templates alike, no
   template edit needed. Anchor (the line goes directly above it):
     new template: the .shopify-block holding .buy-buttons-block
     old template: the ProductInfo section child holding the cart form
   Pages that already hand-code .stock-alert-container are left alone.
   custom.css hides PagePilot's own dashed alarm-clock stock box.
   Re-applied for ~10s because app scripts re-render parts of the page.
   First in the file for the same reason as the gallery block below.
   =================================================================== */
(function () {
  var GIF = 'https://cdn.shopify.com/s/files/1/0767/6339/8478/files/ezgif.com-resize.gif?v=1698232056';
  var COUNT = 3;

  function anchor() {
    var bb = document.querySelector('.buy-buttons-block');
    var block = bb && bb.closest('.shopify-block');
    if (block && block.parentNode) return block;
    var info = document.querySelector('section[id^="ProductInfo-"]');
    if (!info) return null;
    for (var i = 0; i < info.children.length; i++) {
      if (info.children[i].querySelector('form[action*="/cart/add"]')) return info.children[i];
    }
    return null;
  }

  function build() {
    var box = document.createElement('div');
    box.className = 'stock-alert-container zn-stock-auto';
    box.innerHTML =
      '<div class="stock-alert-item">' +
        '<img src="' + GIF + '" width="20" height="20" alt="">' +
        '<div class="text-block-stock">Nur noch <span class="stock-count">' + COUNT + '</span> auf Lager</div>' +
      '</div>';
    return box;
  }

  function inject() {
    if (document.querySelector('.stock-alert-container')) return;
    var a = anchor();
    if (a) a.parentNode.insertBefore(build(), a);
  }

  var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
  var isProduct = (meta && meta.page && meta.page.pageType === 'product') || /\/products\//.test(location.pathname);
  if (!isProduct) return;

  inject();
  document.addEventListener('DOMContentLoaded', inject);
  window.addEventListener('load', inject);
  var runs = 0, timer = setInterval(function () { inject(); if (++runs >= 20) clearInterval(timer); }, 500);
})();

/* ===================================================================
   PAGEPILOT 2.0 GALLERY - VARIANT IMAGE SWAP
   -------------------------------------------------------------------
   The UNIFIED PRODUCT IMAGE MANAGER in layout/theme.liquid swaps the
   gallery photo when a Wizio bundle dropdown changes. Its ppSetImage()
   only knows the OLD PagePilot gallery:

       #pp-image-scroll-container      (by id)
       img.pp-object-contain / cover

   Pages rebuilt on the new PagePilot template (product.pagepilot.<uuid>)
   render a Swiper instead:

       <pagepilot-product-gallery>
         .pp-product-gallery-main  ->  .swiper-slide[data-media-id]
         img.pp-product-gallery-carousel-image

   None of the old selectors match there, so ppGetMainImg() returns null
   and the swap is a SILENT no-op - the reported "image does not change"
   bug. This adds the missing branch for the new gallery and leaves every
   other page untouched:

     - old PagePilot pages render the theme Flickity slideshow, handled
       by the existing hasFlickity() branch
     - this block exits immediately when no Swiper gallery is present

   Lives here rather than in theme.liquid so the 46KB layout file does
   not have to be rewritten. custom.js is loaded on every page via
   <script src="{{ 'custom.js' | asset_url }}" defer>.

   NOTE: this block is FIRST on purpose. The date code below ends with
   document.getElementById("date_clas").innerHTML = ..., which throws on
   every page that has no #date_clas element (product pages included),
   so anything appended after it would never run.
   =================================================================== */
(function () {
  var READY_DELAY = 1500; // mirrors wizioInitDone in theme.liquid
  var ready = false;
  var variantsById = null;

  function mainSwiper() {
    var main = document.querySelector('.pp-product-gallery-main');
    var swiper = main && main.swiper;
    return (swiper && swiper.slides && swiper.slides.length) ? swiper : null;
  }

  // window.KlarnaThemeGlobals.productVariants is set in theme.liquid from
  // {{ product.variants | json }}, so each variant carries featured_media.id
  // and it matches the slide data-media-id exactly. No fetch needed.
  function variantMap() {
    if (variantsById) return variantsById;
    var list = window.KlarnaThemeGlobals && window.KlarnaThemeGlobals.productVariants;
    if (!list || !list.length) return null;
    variantsById = {};
    for (var i = 0; i < list.length; i++) variantsById[String(list[i].id)] = list[i];
    return variantsById;
  }

  // The gallery lazy-loads: hand the slide its real srcset before we show it,
  // otherwise the customer sees an empty frame for a moment.
  function eagerLoad(slide) {
    var imgs = slide.querySelectorAll('img[data-srcset]');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      var sizes = img.getAttribute('data-sizes');
      if (sizes) img.sizes = sizes;
      img.srcset = img.getAttribute('data-srcset');
      img.removeAttribute('data-srcset');
      img.removeAttribute('data-sizes');
    }
  }

  function goToMedia(mediaId) {
    var swiper = mainSwiper();
    if (!swiper || !mediaId) return false;

    var slides = Array.prototype.slice.call(swiper.slides);
    var target = null;
    for (var i = 0; i < slides.length; i++) {
      if (String(slides[i].getAttribute('data-media-id')) === String(mediaId)) {
        target = slides[i];
        break;
      }
    }
    if (!target) return false;

    eagerLoad(target);

    // Index by CURRENT dom order. The gallery runs loop:true and Swiper
    // reorders its slides as the carousel wraps, so a stored position would
    // point at the wrong photo later. Also use slideTo, not slideToLoop -
    // slideToLoop defers through requestAnimationFrame.
    var index = slides.indexOf(target);
    if (index < 0) return false;

    swiper.slideTo(index, 300);
    return true;
  }

  // Same row resolution as findPickerForSelect() in theme.liquid: scope to the
  // active bundle tier and match by row index, so rows 2 and 3 of a "buy 2/3"
  // bundle resolve to their own variant instead of the first row.
  function pickerFor(select) {
    var tier = document.querySelector('.bdl-quantity-item.active') || document;
    var optClass = select.classList.contains('bdl-quantity-options-0')
      ? '.bdl-quantity-options-0'
      : '.bdl-quantity-options-1';
    var rows = Array.prototype.slice.call(tier.querySelectorAll(optClass));
    var rowIndex = rows.indexOf(select);
    if (rowIndex < 0) rowIndex = 0;
    var pickers = Array.prototype.slice.call(tier.querySelectorAll('.bdl-quantity-variants-picker'));
    return pickers[rowIndex] || pickers[0] || document.querySelector('.bdl-quantity-variants-picker');
  }

  function onChange(event) {
    var target = event.target;
    if (!target || !target.classList) return;
    if (!target.classList.contains('bdl-quantity-options-0') &&
        !target.classList.contains('bdl-quantity-options-1')) return;
    if (!ready) return;
    if (!mainSwiper()) return; // old gallery or no PagePilot gallery: leave it alone

    // Wizio rewrites its hidden variant picker after the change event, so read
    // it on the next tick - same 50ms the existing theme script uses.
    setTimeout(function () {
      var map = variantMap();
      var picker = pickerFor(target);
      if (!map || !picker || !picker.value) return;
      var variant = map[String(picker.value)];
      if (!variant || !variant.featured_media) return;
      goToMedia(variant.featured_media.id);
    }, 50);
  }

  function arm() {
    setTimeout(function () { ready = true; }, READY_DELAY);
  }

  function init() {
    document.addEventListener('change', onChange);

    if (document.querySelector('.bdl-quantity-generate')) {
      arm();
      return;
    }
    // The bundle widget renders async; wait for it, then arm.
    var observer = new MutationObserver(function () {
      if (document.querySelector('.bdl-quantity-generate')) {
        observer.disconnect();
        arm();
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { observer.disconnect(); arm(); }, 8000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

var today=new Date,n=today.getDay(),dd=String(today.getDate()).padStart(2,"0"),mm=String(today.getMonth()+1).padStart(2,"0"),yyyy=today.getFullYear(),month="",current_day="";n==1?current_day="Montag":n==2?current_day="Dienstag":n==3?current_day="Mittwoch":n==4?current_day="Donnerstag":n==5?current_day="Freitag":n==6?current_day="Samstag":n==7&&(current_day="Sonntag"),mm==1?month="Januar":mm==2?month="Februar":mm==3?month="M\xE4rz":mm==4?month="April":mm==5?month="Mai":mm==6?month="Juni":mm==7?month="Juli":mm==8?month="August":mm==9?month="September":mm==10?month="Oktober":mm==11?month="November":mm==12&&(month="Dezember"),document.getElementById("date_clas").innerHTML=current_day+", "+dd+". "+month;
//# sourceMappingURL=/s/files/1/0583/6478/8885/t/12/assets/custom.js.map?v=1662149651
